export default {
    "fr": {
        "Blog": "Blog",
        "Contact us": "Nous contacter",
        "Register": "M'inscrire",
        "Login": "Me connecter",
        "My account": "Mon compte"
    },
    "en": {
        "Blog": "Blog",
        "Contact us": "Contact us",
        "Register": "Register",
        "Login": "Login",
        "My account": "My account"
    }
}
